<template>
  <div>
    <div class="row">
      <div :class="['col_12', {'loading_overlay': loading}]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_6">
                <div :class="['form-group', {'has_error': errorFor('top_title')}]">
                  <label>{{ $t('sidebar.home_banner.top_title') }}</label>
                  <input type="text" v-model="form.top_title" class="form_global">
                  <v-errors :errors="errorFor('top_title')" />
                </div>
              </div>
              <div class="col_6">
                <div :class="['form-group', {'has_error': errorFor('bottom_title')}]">
                  <label>{{ $t('sidebar.magazine_slider.bottom_title') }}</label>
                  <input type="text" v-model="form.bottom_title" class="form_global">
                  <v-errors :errors="errorFor('bottom_title')" />
                </div>
              </div>
              <div class="col_6">
                  <div class="form-group ">
                      <label>{{ $t('sidebar.magazine_slider.slider_image') }}</label>
                      <input type="file" ref="slider_image" class="form_global" @input="homeSliderImageUpload($event)">
                      <v-errors :errors="errorFor('slider_image')"></v-errors>
                  </div>
                  <div class="thumbnail_img" v-if="tempSliderImage || form.slider_image">
                      <div class="inner">
                          <img v-if="tempSliderImage" :src="tempSliderImage" alt="" >
                          <img v-else :src="form.slider_image" alt="">
                          <span class="close_icon" @click="removeTempSliderImage"></span>
                      </div>
                  </div>
              </div>
            </div>
            <div class="d_flex_end form_action_btn">
              <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
              <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: this.$t('sidebar.magazine_slider.add_magazine_slider'),
      cancelRouteName: 'magazine_slider_list',
      form: {
        top_title: '',
        bottom_title: '',
        slider_image: ''
      },
      tempSliderImage:'',
    }
  },
  components: {  },
  created() {
    if (this.$route.name === 'magazine_slider_edit') {
      this.axios.get('/magazine-sliders/'+this.$route.params.id)
        .then((response) => {
          this.form = response.data.data;
        })
      this.title = this.$t('sidebar.magazine_slider.edit_magazine_slider');
    }
  },
  methods: {
    homeSliderImageUpload(e) {
        this.form.slider_image = e.target.files[0]
        this.tempSliderImage = URL.createObjectURL(e.target.files[0]);
    },
    removeTempSliderImage(){
        this.tempSliderImage = ''
        this.form.slider_image = ''
        this.$refs.slider_image.value = null;
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
          formData.append(key, this.form[key] ? this.form[key] : '');
      })

      if (this.$route.name === 'magazine_slider_edit') {
        formData.append('_method', 'PUT');
        this.axios.post('/magazine-sliders/'+this.$route.params.id, formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          .then(() => {
            this.$router.push({name: 'magazine_slider_list'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios.post('/magazine-sliders', formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          .then(() => {
            this.$router.push({name: 'magazine_slider_list'});
            this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
}
</script>
<style scoped="css">
    .thumbnail_img .inner img {
        max-width: 200px;
    }
    .thumbnail_img img {
      width: 110px;
    }
    .thumbnail_img img {
        height: 110px;
    }
    .close_icon {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        overflow: hidden;
        cursor: pointer;
        margin-left: 182px;
        margin-top: 3px;
        z-index: 100;
        background: red;
        color: #fff;
        border-radius: 50%;
    }
    .close_icon::before, .close_icon::after {
        content: "";
        position: absolute;
        width: 59%;
        top: 51%;
        left: 4px;
        background: #fff;
        height: 2px;
    }

    .close_icon::before {
        transform: rotate(45deg);
    }
    .close_icon::after {
        transform: rotate(-45deg);
    }
    .thumbnail_img {
        display: inline-flex;
    }
    .thumbnail_img .inner{
        display: inline-flex;
        position: relative;
    }
    .thumbnail_img .close_icon{
        margin-left: 0;
        position: absolute;
    }
    
</style>